import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'workflows',
  children: {
    template: {
      path: ':category',
      children: {
        create: {
          path: 'create',
        },
        new: {
          path: 'new',
        },
        id: {
          path: 'workflow/:id',
          children: {
            processInstance: {
              path: 'workflow-instance/:materializedProcessId',
              children: {
                completeProcess: {
                  path: 'complete-workflow',
                },
                item: {
                  path: 'item/:materializedItemId',
                },
              },
            },
            employees: {
              path: 'employees',
              children: {
                new: {
                  path: 'new',
                },
                removeMaterialized: {
                  path: 'remove-workflow-instance/:materializedProcessId',
                },
                updateStatus: {
                  path: 'complete-workflow/:materializedProcessId',
                },
                edit: {
                  path: 'edit',
                },
              },
            },
            settings: {
              path: 'settings',
              children: {
                publish: {
                  path: 'publish',
                },
                createStep: {
                  path: 'step',
                },
                editStep: {
                  path: 'step/:stepId',
                },
                duplicate: {
                  path: 'step/:stepToDuplicateId/duplicate',
                },
                edit: {
                  path: 'edit',
                },
              },
            },
            overview: {
              path: 'overview',
              children: {
                sendReminder: {
                  path: 'send-reminder',
                },
              },
            },
            publish: {
              path: 'publish',
            },
          },
        },
        edit: {
          path: 'edit/:id',
        },
        duplicate: {
          path: 'duplicate/:id',
        },
        delete: {
          path: 'delete/:id',
        },
        teaser: {
          path: 'teaser',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
